module.exports = __webpack_public_path__ + "assets/logo-foxgid.ce02e12f.svg";